/**
 * Temporary scaffold block for routes whose UI is not built yet. Each one names
 * the PRD feature it stands in for so the build-out is self-documenting.
 */
export function PagePlaceholder({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="mx-auto max-w-6xl px-4 py-12">
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
      <div className="mt-3 max-w-2xl rounded-lg border border-dashed border-gray-300 bg-white p-6 text-gray-600">
        {children}
      </div>
    </div>
  );
}
